module.exports = __webpack_public_path__ + "static/nodejs-b4b15009a108dc3bb88e62d8d06ebec7.svg";